import { TooltipProvider } from "@/components/ui/tooltip";
import {
  CanvasFloatingToolbarFrame,
  CanvasToolbarDivider,
} from "../components/toolbar";
import { NodeToolbarContextMenuButton } from "./shared/NodeToolbarContextMenuButton";

interface WidgetFloatingToolbarProps {
  toolbarSlot?: React.ComponentType<{
    id: string;
    data: Record<string, unknown>;
  }>;
  nodeId: string;
  nodeData: Record<string, unknown>;
}

export function WidgetFloatingToolbar({
  toolbarSlot: ToolbarSlot,
  nodeId,
  nodeData,
}: WidgetFloatingToolbarProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <CanvasFloatingToolbarFrame
        onMouseDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        {ToolbarSlot && <ToolbarSlot id={nodeId} data={nodeData} />}

        {ToolbarSlot && <CanvasToolbarDivider />}

        <NodeToolbarContextMenuButton nodeId={nodeId} />
      </CanvasFloatingToolbarFrame>
    </TooltipProvider>
  );
}
